/* @flow */

export const cachedChatStreams = (root: *) => {
  const ids = [];

  // fetch all the root query starting by chatStream:
  //
  // {
  //   me: {},
  //   chatStreams({"chatUuids":["1b75bef4-5629-45af-9dac-95d2fd663430"]}): [],
  //   chatStreams({"chatUuids":["ebc5e4a2-11d5-11e8-b642-0ed5f89f718b"]}): [],
  //   chatStreams({"chatUuids":["f03465fe-11d5-11e8-b642-0ed5f89f718b"]}): [],
  // }
  //
  // and return an array of their response item data key.
  Object.keys(root).forEach(key => {
    if (key.startsWith('chatStreams')) {
      root[key].forEach(item => ids.push(item));
    }
  });

  return ids;
};
